import pt from '@/locales/pt.json';
import br from '@/locales/br.json';
import en from '@/locales/en.json';
import es from '@/locales/es.json';
import ar from '@/locales/ar.json';
import ru from '@/locales/ru.json';
import fr from '@/locales/fr.json';
import it from '@/locales/it.json';
import de from '@/locales/de.json';

export default function getMyFavouriteLanguage(group, code, storeLanguage) {

    let lang = [];

    switch (storeLanguage) {
        case "pt":
            lang = pt;
            break;

        case "br":
            lang = br;
            break;

        default:
        case "en":
            lang = en;
            break;

        case "es":
            lang = es;
            break;

        case "ar":
            lang = ar;
            break;

        case "ru":
            lang = ru;
            break;

        case "fr":
            lang = fr;
            break;

        case "it":
            lang = it;
            break;

        case "de":
            lang = de;
            break;
    }

    return lang.filter((item) => item.group === group).filter((item) => item.code === code).map(item => item.value).join();
}